








export default {
  name: 'AppToggle',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    labelAlign: {
      type: String,
      default: 'left',
      validator: (value: string) =>
        ['right', 'left', 'top', 'bottom'].indexOf(value) !== -1,
    },
    labelText: {
      type: String,
    },
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val: boolean) {
        this.$emit('input', val);
      },
    },
    getCssClass() {
      return {
        label_right: this.labelAlign === 'right',
        label_left: this.labelAlign === 'left',
        label_top: this.labelAlign === 'top',
        label_bottom: this.labelAlign === 'bottom',
      };
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppToggle/AppToggle.vue